import { onMounted } from "vue";
import { usePage } from "@inertiajs/vue3";
import { create } from "@/composables/useNotifications";
import { useTranslations } from "@/composables/useTranslations";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";

export const useDomainGuideRedirectNotice = () => {
    const page = usePage<IRhizomPageProps>();
    const { t } = useTranslations();

    onMounted(() => {
        if (page.props.domainGuideRedirectNotice !== true) {
            return;
        }

        create({
            title: t("vue.domain_wizard_redirect_notice_title"),
            text: t("vue.domain_wizard_redirect_notice_text"),
            type: "warning",
        });
    });
};
